import { useEffect } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { useRouter } from 'expo-router';
import { useAuth } from '@/hooks/useAuth';
import { useSelfStudent } from '@/hooks/useSelfStudent';

/**
 * Entry point do "Meu treino": garante que o self-student exista e redireciona
 * pro app do aluno — reusa 100% da UI (home, calendário, rotinas, progresso).
 * O HamburgerDrawer dentro do (student) mostra "Voltar pro Personal" quando
 * o profile.role é personal.
 */
export default function MyWorkoutEntry() {
  const router = useRouter();
  const { profile } = useAuth();
  const { selfStudent, loading, creating, ensureSelfStudent } = useSelfStudent(profile);

  useEffect(() => {
    let cancelled = false;
    async function go() {
      if (!profile || loading || creating) return;
      try {
        if (!selfStudent) await ensureSelfStudent();
      } catch {
        // Se falhar, o user volta ao tocar atrás
      }
      if (!cancelled) router.replace('/(student)/(tabs)' as never);
    }
    go();
    return () => { cancelled = true; };
  }, [profile, loading, creating, selfStudent, ensureSelfStudent, router]);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <ActivityIndicator color="#C8102E" />
    </View>
  );
}
